import visual from 'assets/images/community/visual.png';

export const krFaq = {
  title: `커뮤니티`,
  subTitle: `Community`,
  subject: `자주묻는질문`,
  subjectDesc: `FAQ`,
  visual,
};

export const enFaq = {
  title: `커뮤니티`,
  subTitle: `Community`,
  subject: `FAQ`,
  subjectDesc: `FAQ`,
  visual,
};
